import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { revisionCardMessages } from '../assets/revisionCardMessages';
import { unlockMessages } from './unlockMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cards and the preview line */
import styles from './UnlockCards.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface FirstImagesHeaderProps {
  /** The images of the first kit that still render. */
  count: number;
}

/**
 * "New · Your first images · 12 on the way · about a minute" (design: onboarding c5). It leads the
 * Assets tab of the first release while the free images of "Add my song" render, in place of the
 * working banner.
 */
const FirstImagesHeaderComponent: React.FC<FirstImagesHeaderProps> = ({ count }) => {
  const intl = useIntl();
  return (
    <div className={styles.firstImages} role="status" data-testid="first-images-header">
      <span className={styles.newTag}>{intl.formatMessage(revisionCardMessages.newTag)}</span>
      <b>{intl.formatMessage(unlockMessages.firstImages)}</b>
      <small>{intl.formatMessage(unlockMessages.firstImagesCount, { count })}</small>
    </div>
  );
};

export const FirstImagesHeader = TypedMemo(FirstImagesHeaderComponent);
